/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_OfflineInputs */

const en_us2_shell_offline = /** @type {(inputs: Shell_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

const pt_br2_shell_offline = /** @type {(inputs: Shell_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem conexão`)
};

const es_419_shell_offline = /** @type {(inputs: Shell_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conexión`)
};

const pt_pt2_shell_offline = /** @type {(inputs: Shell_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem ligação`)
};

const fr_fr2_shell_offline = /** @type {(inputs: Shell_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors ligne`)
};

const de_de2_shell_offline = /** @type {(inputs: Shell_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

const it_it2_shell_offline = /** @type {(inputs: Shell_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

/**
* | output |
* | --- |
* | "Offline" |
*
* @param {Shell_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_offline = /** @type {((inputs?: Shell_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_offline(inputs)
	if (locale === "es-419") return es_419_shell_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_offline(inputs)
	if (locale === "de-DE") return de_de2_shell_offline(inputs)
	if (locale === "it-IT") return it_it2_shell_offline(inputs)
	return en_us2_shell_offline(inputs)
});
export { shell_offline as "shell.offline" }